import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { v4 as uuid4 } from 'uuid';
import { Application, Customer, PayDues } from './application.service';
import { environment } from 'src/environments/environment';
import { ActivityTrackingService } from './activity-tracking.service';
import { EmploymentInformation } from '../interfaces/employment-information';
import { ApplicationRules } from './journey-rules.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  public ApiUrl: string = environment.ApiUrl;
  public ImageUrl: string = environment.ImageUrl;
  public uteUrl: string = environment.UteUrl;
  public CheckoutPublicKey: string = environment.CheckoutPublicKey;
  public GoogleTagProd: boolean = environment.GoogleTagProd;
  public showPromoCodeNonPF: boolean = environment.showPromoCodeNonPF;
  public showPromoCodePF: boolean = environment.showPromoCodePF;
  public calculateEligibilityFirst: boolean = environment.calculateEligibilityFirst;

  public AppJourneyBaseUrl = '/board-main/application-main/';

  public GeoLocationStoreBaseUrl = '/board-main/geolocation-store/';
  public token: string | null = sessionStorage.getItem('token');
  public runPlatform: string | 'Website' = sessionStorage.getItem('runPlatform') || 'Website';

  ApiKey: string = '58d4c8fd-f704-49ba-ae38-4dd20a5bea00';
  amount = 0;
  merchantId: string = '';
  clientId!: string;
  CurrentLang: any;
  isEmailVerified = false;
  iban: string = sessionStorage.getItem('iban') || '';
  CivilId: string = sessionStorage.getItem('civilId') || '';
  utmIdStorageKey = 'utmId';

  tellNumber: number = 8003044434;

  public get isSaudi() {
    return this.CivilId[0] == '1';
  }

  sayen = sessionStorage.getItem('sayen') || '';
  constructor(private router: Router, private activityTrackingService: ActivityTrackingService) {
    localStorage.setItem('isGoogleTagEnabled', 'true'); // Wael

    let clientId = localStorage.getItem('clientId');
    if (!clientId && !sessionStorage.getItem('mobile')) {
      this.clientId = uuid4();
      localStorage.setItem('clientId', this.clientId);
    }
    else
      this.clientId = clientId!;
  }

  set clientIdValue(val: string) {
    this.clientId = val;
    localStorage.setItem('clientId', val);
  }

  public static get GettempToken() {
    var temp = sessionStorage.getItem(`temptoken`);
    return temp;
  }

  get IsMerchant() {
    return sessionStorage.getItem('MerchantId') || false;
  }

  public static get GetCustomer() {
    var temp = sessionStorage.getItem(`C`);
    var KaizenStorage: Customer = {};
    if (temp)
      KaizenStorage = JSON.parse(temp);
    return KaizenStorage;
  }

  public static get isGoogleTagEnabled() {
    return localStorage.getItem('isGoogleTagEnabled') == 'true';
  }

  public static get isTomiAiEnabled() {
    return environment.isTomiAiEnabled;
  }

  public static enableGoogleTag() {
    localStorage.setItem('isGoogleTagEnabled', 'true');
  }

  public static disableGoogleTag() {
    localStorage.setItem('isGoogleTagEnabled', 'false');
  }

  public static get GetApplication() {
    var temp = sessionStorage.getItem(`Application`);
    var KaizenStorage: Application = {
      JourneyTrackingId: null
    };
    if (temp)
      if (JSON.parse(JSON.stringify(sessionStorage.getItem('journeyTrackingId')!))) {
        KaizenStorage = { ...JSON.parse(temp), JourneyTrackingId: JSON.parse(JSON.stringify(sessionStorage.getItem('JourneyTrackingId')!)) };
      } else {
        KaizenStorage = { ...JSON.parse(temp) };
      }

    return KaizenStorage;
  }

  public static get GetApplicationRules() {
    var temp = sessionStorage.getItem(`ApplicationRules`);
    var KaizenStorage: ApplicationRules = {} as ApplicationRules;
    if (temp)
      KaizenStorage = JSON.parse(temp);
    return KaizenStorage;
  }

  public static get getEmploymentDetails() {
    var temp = sessionStorage.getItem(`EmploymentDetails`);
    var KaizenStorage: EmploymentInformation = { StagingId: '' };
    if (temp)
      KaizenStorage = JSON.parse(temp);
    return KaizenStorage;
  }

  public static get GetPayDues() {
    var temp = sessionStorage.getItem(`PayDues`);
    var KaizenStorage: PayDues = {};
    if (temp)
      KaizenStorage = JSON.parse(temp);
    return KaizenStorage;
  }

  setUtmID(id: number) {
    sessionStorage.setItem(this.utmIdStorageKey, JSON.stringify(id));
  }

  public get utmID() {
    const utmId = sessionStorage.getItem(this.utmIdStorageKey);
    return utmId ? JSON.parse(utmId) : 0;
  }

  public assignReferrer() {
    const currentHost = window.location.protocol + '//' + window.location.host;
    const referralURL = document.referrer;
    if (sessionStorage.getItem('referrer') == undefined || sessionStorage.getItem('referrer') == null || sessionStorage.getItem('referrer') == '') {
      let isExternalReferral = !referralURL.startsWith(currentHost) && referralURL.length !== 0;
      if (isExternalReferral)
        sessionStorage.setItem('referrer', referralURL);
    }
  }

  goBack(event: boolean = false) {
    this.activityTrackingService.backButtonClicked();
    window.history.back();
  }

  goToHome() {
    if (sessionStorage.getItem('IframOrigin'))
      return;

    if (sessionStorage.getItem('contract') == 'true') {
      this.router.navigate(['fc']);
      return;
    }

    if (sessionStorage.getItem('mobile'))
      (window as any).exitWebView();
    else
      this.router.navigate(['landing']);
  }

  clearAppLocalSession() {
    console.log('clearAppLocalSession');
    sessionStorage.removeItem('ApplicationRules');
    sessionStorage.removeItem('Application');
    sessionStorage.removeItem('productId');
    sessionStorage.removeItem('AppId');
    sessionStorage.removeItem('selectedMerchant');
    sessionStorage.removeItem('selectedMerchantBranch');
    sessionStorage.removeItem('journeyTrackingId');
  }

  logout() {
    this.token = null;
    sessionStorage.clear();
    this.router.parseUrl('landing');
  }

  sendIframeToElement(data: any) {
    if (sessionStorage.getItem('IframOrigin')) {
      const origin = String(sessionStorage.getItem('IframOrigin'));
      window.parent.postMessage(data, origin); // You may want to specify the target origin instead of '*'
    }
  }
}

@Injectable({
  providedIn: 'root',
})
export class CurrentUI {
  get CanSubmitNewApplications() {
    return JSON.parse(
      sessionStorage.getItem('canSubmitApplication') || 'false'
    );
  }
  set CanSubmitNewApplications(val: boolean) {
    sessionStorage.setItem('canSubmitApplication', val.toString());
  }
  get CurrentTap() {
    return sessionStorage.getItem('currentTap') || '';
  }
  set CurrentTap(val: string) {
    sessionStorage.setItem('currentTap', val);
  }
}
